import type { components } from '@/api'
import { exhaustiveGuard } from '@/shared/utils/typeAssertions'
import {
  isRawDirectFieldInput,
  isRawDirectHubInput,
  isRawRelatedPropertyInput,
  isRawViaReferenceInput,
} from './rawTypeGuards'
import type {
  DirectFieldPropertyInput,
  DirectHubPropertyInput,
  PropertyInput,
  RelatedPropertyInput,
  ViaReferencePropertyInput,
} from './types'

type ApiPropertyInput = components['schemas']['Projects.PropertyInputResponse']

/**
 * Deserializes API property input response to frontend PropertyInput type
 */
export function serializePropertyInput(apiInput: ApiPropertyInput): PropertyInput {
  if (isRawDirectHubInput(apiInput)) {
    return {
      type: 'directHub',
      directHubId: apiInput.direct_hub_id,
    } as DirectHubPropertyInput
  } else if (isRawDirectFieldInput(apiInput)) {
    return {
      type: 'directField',
      propertyId: apiInput.property_id,
      entityId: apiInput.entity_id,
    } as DirectFieldPropertyInput
  } else if (isRawViaReferenceInput(apiInput)) {
    return {
      type: 'viaReference',
      propertyId: apiInput.property_id,
      viaPropertyId: apiInput.via_property_id,
      filters: apiInput.entities_filter,
    } as ViaReferencePropertyInput
  } else if (isRawRelatedPropertyInput(apiInput)) {
    return {
      type: 'related',
      propertyId: apiInput.property_id,
      filters: apiInput.entities_filter,
    } as RelatedPropertyInput
  } else {
    return exhaustiveGuard(apiInput, `Unknown input type: ${JSON.stringify(apiInput)}`)
  }
}
